<template>
  <div class="overall-bg">
    <!-- {{ contactTableList }} -->
    <!-- {{ liveContactTableList }} -->
    <div class="table-width-80" v-if="windowWidth > 545">
      <Tableview :value="liveContactTableList" :paginator="true" class="p-datatable-gridlines" :rows="10"
        :rowHover="true" filterDisplay="menu" :loading="loading1" responsiveLayout="scroll" :columns="headers"
        :globalFilterFields="globalFilterFields" :filters="filters" :options="liveContactTableList"
        selectionMode="single" @row-click="RowClick" :totalRecords="rowsCount">
        <!-- <template v-slot:Add v-if="addNew == false">
                    <span class="add">
                        <AddButton @click="IsAdd" :btnname=" $t('btn.plusaddnew')" class="float-rights my-3">
                        </AddButton>
                    </span>
                </template> -->
        <template v-slot:Status="{ data }">
          <Badge v-if="data.IsActive == '0'" severity="warning">{{
            "InActive"
          }}</Badge>
          <Badge v-if="data.IsActive == '1'" severity="success">{{
            "Active"
          }}</Badge>
        </template>
        <template v-slot:statusData="{ data }">
          <!-- {{ data }} -->
          <Badge v-if="data.Status == 'answered'" severity="success">{{
            "Answered"
          }}</Badge>
          <Badge v-if="data.Status == 'missed'" severity="danger">{{
            "Missed Call"
          }}</Badge>
        </template>
        <template v-slot:action="{ data }">
          <span>
            <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
              @click="toggle($event, data)" />
          </span>
        </template>
      </Tableview>
    </div>
    <div v-if="windowWidth <= 545">
      <div class="field">
        <TextFields v-model="filterText.textFilter" id="Search" name="Search" label="" placeholder="Search "
          @Update:modelValue="filtereditems" />
      </div>
      <div class="mobile-card" v-for="items in paginatedItems">
        <div class="">
          <p class="name">
            {{ items.agent_name }}
            <span class="callicons"><img v-if="items.type === 'Extension'" class="callicons"
                src="../../../../assets/Img/icons/outgoingcall.svg" /><img v-else class="callicons"
                src="../../../../assets/Img/icons/incomingcall.svg" /></span>
          </p>
          <p class="name">
            <span class="callicons"><img v-if="items.state === 'Answered'" class="callicons"
                src="../../../../assets/Img/icons/callanswer.svg" /><img v-else class="callicons"
                src="../../../../assets/Img/icons/missedcall.svg" /></span>{{ items.customer_number }}
          </p>
        </div>
        <!-- <p class="small-light-txt"><span class="callicons"><img v-if="items.status === 'answered'" class="callicons"
              src="../../../../assets/Img/icons/callanswer.svg"><img v-if="items.status === 'missed'" class="callicons"
              src="../../../../assets/Img/icons/missedcall.svg"></span>{{ items.calldatetime }} <span
            v-if="items.callDuration && items.status === 'answered'">({{ items.callDuration
            }})</span></p> -->
      </div>
      <div class="d-flex justify-content-center">
        <b-pagination v-model="currentPage" :total-rows="mobilerows" :per-page="perPage" size="md"
          aria-controls="my-table"></b-pagination>
      </div>
    </div>
  </div>

  <!-- Commenly Used Components -->
  <Menu ref="menu" id="overlay_menu" :model="itemListed" @click="" :popup="true" />
  <CallrightsidebarVue :visibleRight="VisibleRight" :isFormdata="isFormData" :status="true"
    @close="closerightsidebar()" />

  <ActivatedSuccessfully :visible="pop.activatepop" @ok="closetrigger()" />
  <InActivatedSuccessfully :visible="pop.inactivepop" @ok="closetrigger()" />
  <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit(dataEdit)" @no="Editmodel = false"
    :content="$t('confirmation.editcontent')" />
  <DeleteConfirmationVue :DeleteModel="Deletemodel" :content="contentdel" @yes="IsDelete(dataEdit)"
    @no="Deletemodel = false" />
  <DeletedSuccessfully :visible="deletepop" @ok="closetrigger()" />
  <Mapping :visible="MappingPop.visible" @ok="closetrigger()" :content="MappingPop.content" />
  <AssignTo v-model:trigger="assignpop" v-if="assignpop" v-model:selected-item="assignpopdata" @load="assignpop = false"
    @close="assignpop = false" @loaderhide="loading = false" @loadershow="loading = false" />
  <!-- Commenly Used Components -->
</template>

<script lang="ts">
// import Header from '../../components/Layout/Header.vue';
import { defineComponent, ref, h, computed, onMounted, onUnmounted } from "vue";

import Headerlayout from "../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../components/FormComponents/BacktoMaster.vue";
import CallrightsidebarVue from "../../components/tasks/callrightsidebar.vue";

import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../components/FormComponents/Table.vue";
import { useI18n } from 'vue-i18n';
import LiveCallService from "../../service/liveCallsService";

import Mapping from "../../../../components/FormComponents/Mapping.vue";
import MasterEmpty from "../../../../components/Masters/MasterEmpty.vue";
import Loader from "../../../../components/FormComponents/Loader.vue";
import { RouterLink, RouterView, useRouter } from "vue-router";
import AssignTo from "../../pages/contact/assignTo.vue";

import EditConfirmation from "../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../components/FormComponents/DeletedSuccessfully.vue";
import ActivatedSuccessfully from "../../../../components/FormComponents/ActivateSuccessfully.vue";
import InActivatedSuccessfully from "../../../../components/FormComponents/InActivateSuccessfully.vue";
import leadSourceCreation from "../../pages/masters/leadSourceMaster/leadSourceCreation.vue";
import { useHotkey } from "v-hotkey3";

export default defineComponent({
  components: {
    // Header,
    CallrightsidebarVue,
    AssignTo,
    BacktoPage,
    Headerlayout,
    Tableview,
    EditConfirmation,
    DeleteConfirmationVue,
    DeletedSuccessfully,
    Mapping,
    MasterEmpty,
    Loader,
    ActivatedSuccessfully,
    InActivatedSuccessfully,
    leadSourceCreation,
  },
  props: {
    addNew: {
      type: Boolean,
      default: false,
    },
    contactType: {
      type: Number,
      default: 1,
    },
    liveContactTableList: {
      type: Array,
      default: [],
    },
  },
  setup(props) {
    const filter = "";
    const showmodalref = ref(false);
    const VisibleRight = ref(false);
    const isFormData = ref();

    const clases = ref(0);
    const childRef = ref();
    let loading1 = ref(false);
    const showDialog = ref(false);
    const rowFocus = ref(false);
    const editItems = ref();
    let assignpop = ref(false);
    let assignpopdata = ref();
    const Editmodel = ref(false);
    const { t } = useI18n();
    const Deletemodel = ref(false);
    const deletepop = ref(false);
    const contactTableList = ref([]);
    const router = useRouter();
    const MappingPop = ref({
      visible: false,
      content: "",
    });
    let loading = ref(false);
    const pop = ref({
      activatepop: false,
      inactivepop: false,
    });
    const contentdel = ref("");
    let InActivevisible = ref(false);
    let Activevisible = ref(false);
    const datas = ref();
    const menu = ref();
    const rowsCount = ref(0);
    debugger;

    //   let List = ref([]);
    let List = ref([]);
    let filterText = ref({
      textFilter: "",
    });
    let liveContactTableList: any = ref(props.liveContactTableList);
    let OriginalList: any = ref([]);
    const currentPage = ref(1);
    const perPage = ref(5);
    let mobilerows = ref();
    OriginalList.value = liveContactTableList.value;
    mobilerows.value = OriginalList.value.length;

    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    onMounted(() => {
      window.addEventListener("resize", handleResize);
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });
    const headers = [
      // {
      //   header: "S.No",
      //   field: "Rownumber",
      //   class: "filterdisplaynone",
      // },
      {
        header: "Call Type",
        field: "type",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      {
        header: "Call Id",
        field: "call_id",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },

      {
        header: "customer number",
        // slot: "state",
        field: "customer_number",
        class: "filterdisplaynone",
      },
      {
        header: "Agent Name",
        field: "agent_name",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      // {
      //   header: "Status",
      //   // slot: "state",
      //   field: "state",
      //   class: "filterdisplaynone",
      // },
      {
        header: "Status",
        // slot: "state",
        field: "state",
        class: "filterdisplaynone",
      },
      // {
      //   header: "queue_state",
      //   field: "queue_state",
      //   filterTemplate: "MultiSelect",
      //   ShowMactchMode: false,
      // },

      // {
      //     header: "Status",
      //     field: "RowNumber",
      //     class: 'filterdisplaynone'
      // },
      // {
      //     header: "Open followup call",
      //     field: "Openfollowtask",
      //     slot: "Assignedtype",
      //     filterTemplate: "MultiSelect",
      //     ShowMactchMode: false,
      //     bodyclass: 'boldclass',
      // },

      // {
      //   // class: "filterdisplaynone",
      //   field: "action",
      //   header: "",
      //   slot: "action",
      // frozencolumn: true,
      //   sortable: false,
      // },

      {
        class: "filterdisplaynone last-column-position",
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        fieldDisplay: "false",
        sortable: false,
      },
    ];
    function closerightsidebar() {
      VisibleRight.value = false;
    }
    const filteredColumns = computed(() => {
      return headers.filter((col) => col.field !== "id");
    });
    const globalFilterFields = ref(headers.map((col) => col.field));

    let OrganizationId = ref();
    let localstoragedata = ref();

    onMounted(() => {
      localstoragedata.value = localStorage.getItem("UsersData");
      localstoragedata.value = JSON.parse(localstoragedata.value);
      OrganizationId.value = localstoragedata.value.OrganizationId;
      debugger;
      IsShow();
    });

    const dataEdit = ref();
    function toggle(event, data) {
      debugger;
      console.log(event);
      if (data.IsActive == 1) {
        InActivevisible.value = true;
        Activevisible.value = false;
      } else {
        InActivevisible.value = false;
        Activevisible.value = true;
      }

      datas.value = data;
      // Id.value = event.Id
      menu.value.toggle(event);
    }

    const itemListed = ref([
      {
        items: [
          // {
          //   label: "Add Details",
          //   icon: "editicon pi pi-pencil",
          //   visible: true,
          //   command: async () => {
          //     IsConfirmEdit(datas.value);
          //   },
          // },
          // {
          //   label: "Convert to lead",
          //   icon: "editicon pi pi-pencil",
          //   visible: props.contactType == 1 ? true : false,
          //   command: async () => {
          //     convertToLead(datas.value);
          //   },
          // },
          // {
          //   label: "Assign To",
          //   icon: "editicon pi pi-pencil",
          //   visible: true,
          //   command: async () => {
          //     assignPerson(datas.value);
          //   },
          // },

          // {
          //   label: "Re Assign",
          //   icon: "editicon pi pi-check-circle",
          //   visible: Activevisible,
          //   command: async () => {
          //     IsConfirmDel(datas.value, 1);
          //   },
          // },
          // {
          //   label: "Edit",
          //   icon: "editicon pi pi-pencil",
          //   visible: InActivevisible,
          //   command: async () => {
          //     IsConfirmEdit(datas.value);
          //   },
          // },
          // {
          //   label: "Delete",
          //   icon: "deleteicon pi pi-trash",
          //   visible: true,
          //   command: async () => {
          //     IsConfirmDel(datas.value, 0);
          //   },
          // },

          // {
          //   label: "Active",
          //   icon: "editicon pi pi-check-circle",
          //   visible: Activevisible,
          //   command: async () => {
          //     IsConfirmDel(datas.value, 1);
          //   },
          // },
          // {
          //   label: "InActive",
          //   icon: "deleteicon pi pi-minus-circle",
          //   visible: InActivevisible,
          //   command: async () => {
          //     IsConfirmDel(datas.value, 2);
          //   },
          // },
          {
            label: "Edit",
            icon: "editicon pi pi-pencil",
            visible: true,
            command: async () => {
              IsConfirmEdit(datas.value);
            },
          },
        ],
      },
    ]);

    function RowClick(event: any) {
      debugger;
      // Editmodel.value = true;
      rowFocus.value = true;
      dataEdit.value = event.data;
      isFormData.value = event.data;
      isFormData.value.Phone = event.data.customer_number;
      isFormData.value.PhoneNumber = event.data.customer_number;
      VisibleRight.value = true;
    }

    function IsAdd() {
      debugger;
      router.push({
        path: "adddetailsform",
        query: {
          Type: props.contactType,
        },
      });
    }

    function IsConfirmEdit(data) {
      debugger;
      dataEdit.value = data;
      Editmodel.value = true;
    }

    function IsConfirmDel(data, Status) {
      debugger;
      data.ActiveStatus = Status;
      dataEdit.value = data;
      Editmodel.value = false;
      if (Status == 1) {
        contentdel.value = t('confirmation.activecontent');
      } else if (Status == 2) {
        contentdel.value = t('confirmation.inactivecontent');
      } else {
        contentdel.value = t('confirmation.deletecontent');
      }
      Deletemodel.value = true;
    }

    // Popup-Close
    function closetrigger() {
      deletepop.value = false;
      pop.value.activatepop = false;
      pop.value.inactivepop = false;
      MappingPop.value.visible = false;
    }

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Name: { value: null, matchMode: FilterMatchMode.IN, options: List },
      StoreName: { value: null, matchMode: FilterMatchMode.IN, options: List },
      BranchId: { value: null, matchMode: FilterMatchMode.IN, options: List },
      RackName: { value: null, matchMode: FilterMatchMode.IN, options: List },
      RowName: { value: null, matchMode: FilterMatchMode.IN, options: List },
      RooName: { value: null, matchMode: FilterMatchMode.IN, options: List },
      ActiveStatus: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },

      CreatedAt: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
      },
      Code: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
      length: {
        operator: FilterOperator.OR,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
    };
    const callid = ref();

    async function IsShow() {
      loading.value = true;
      try {
        const result = await LiveCallService.getList();
        console.log(result);
        result["result"] = result["result"]
          .filter((item) => item.ClientId == OrganizationId.value)
          .map((item) => {
            item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
            return item;
          });
        contactTableList.value = result["result"];
        // .filter((item) => item.customer_number == "+91" + props.isFormdata.WhatsAppNo && item.CallStatus == 0);
        loading.value = false;
        callid.value = contactTableList.value[0]["call_id"];
      } catch (error) {
        loading.value = false;
      }
    }
    // async function IsShow() {
    //     loading.value = true;
    //     debugger;
    //     try {
    //         const result = await LiveCallService.getCallList();
    //         if (result["result"].length > 0) {
    //             rowsCount.value = result["result"].length;
    //         }
    //         console.log(result);
    //         result["result"] = result["result"].map((item) => {
    //             item.ActiveStatus = (item.IsActive == 1) ? 'Active' : 'Inactive'
    //             return item
    //         })
    //         contactTableList.value = result["result"]
    //         // .filter((item) => item.Type == props.contactType);
    //         loading.value = false;
    //     } catch (error) {
    //         loading.value = false;
    //     }
    // }

    // //Edit Box
    // function IsEdit(data) {
    //   debugger;
    //   editItems.value = data;
    //   showDialog.value = true;
    //   Editmodel.value = false;

    //   router.push({
    //     path: "/contactCreation",
    //     query: {
    //       ID: data.ContactId,
    //       // Type: props.contactType,
    //       Type: 0,
    //       OperationID: 690,
    //     },
    //   });
    // }

    function IsEdit(data) {
      debugger;
      editItems.value = data;
      showDialog.value = true;
      Editmodel.value = false;

      const queryString = new URLSearchParams({
        ID: data.contactId,
        Type: "0", // Ensure Type is of string type
        OperationID: String(690), // Ensure OperationID is of string type
      }).toString();

      const newTabUrl = `#/contactCreation?${queryString}`;

      window.open(newTabUrl, "_blank");
    }

    function convertToLead(data) {
      debugger;
      editItems.value = data;
      showDialog.value = true;
      router.push({
        path: "/adddetailsform",
        query: {
          ID: data.Id,
          status: "convertToLead",
          Type: 2,
        },
      });
      // Editmodel.value = false;
    }
    //assign Box
    function assignPerson(data) {
      debugger;
      assignpopdata.value = data;
      assignpop.value = true;

      // Editmodel.value = false;
    }
    //Delete Box
    async function IsDelete(data) {
      loading.value = true;
      const DelID = data.Id;
      debugger;
      try {
        data.ActiveStatus;
        let result: any = "";
        if (data.ActiveStatus == 0) {
          result = await LiveCallService.delete(DelID);
        } else {
          let status = data.ActiveStatus == 1 ? true : false;
          result = await LiveCallService.active(DelID, status);
        }
        let message = result["ErrorInfo"].ErrorCode;
        //if (result["result"] != "False" && message == null) {
        // Deletemodel.value = false;
        // loading.value = false;
        // MappingPop.value.content = result["result"];
        // MappingPop.value.visible = true;
        //}
        if (message == null) {
          if (data.ActiveStatus == 1) {
            pop.value.activatepop = true;
          } else if (data.ActiveStatus == 2) {
            pop.value.inactivepop = true;
          } else {
            deletepop.value = true;
          }
          Deletemodel.value = false;
          loading.value = false;
          rowFocus.value = false;
          IsShow();
        }
      } catch (error) {
        loading.value = false;
      }
    }
    useHotkey({
      esc: () => {
        closetrigger();
      },
      e: () => {
        IsConfirmEdit(dataEdit.value);
      },
      y: () => {
        IsEdit(dataEdit.value);
      },
      n: () => {
        // closetrigger()
        (Editmodel.value = false), (Deletemodel.value = false);
      },
      d: () => {
        IsConfirmDel(dataEdit.value, 0);
      },
      "ctrl+y": () => {
        IsDelete(dataEdit.value);
      },
      "ctrl+a": () => {
        IsConfirmDel(dataEdit.value, 1);
      },
      "ctrl+d": () => {
        IsConfirmDel(dataEdit.value, 2);
      },
      "alt+n": {
        keydown() {
          IsAdd();
        },
      },
    });
    const paginatedItems = computed(() => {
      const startIndex = (currentPage.value - 1) * perPage.value;
      const endIndex = startIndex + perPage.value;
      return OriginalList.value.slice(startIndex, endIndex);
    });
    function filtereditems() {
      debugger;
      OriginalList.value = liveContactTableList.value.filter((person) => {
        const searchValue = String(filterText.value.textFilter).toLowerCase();
        return Object.values(person).some((value) =>
          String(value).toLowerCase().includes(searchValue)
        );
      });
    }
    return {
      currentPage,
      liveContactTableList,
      perPage,
      mobilerows,
      paginatedItems,
      filterText,
      filtereditems,
      OriginalList,
      isFormData,
      VisibleRight,
      closerightsidebar,
      assignpopdata,
      assignpop,
      contactTableList,
      clases,
      List,
      filter,
      Editmodel,
      showmodalref,
      showpopModal: showmodalref,
      childRef,
      IsShow,
      headers,
      loading1,
      filters,
      globalFilterFields,
      filteredColumns,
      showDialog: showDialog,
      IsDelete,
      editItems,
      IsEdit,
      RowClick,
      IsAdd,
      IsConfirmEdit,
      IsConfirmDel,
      Deletemodel,
      closetrigger,
      deletepop,
      dataEdit,
      MappingPop,
      rowsCount,
      loading,
      toggle,
      itemListed,
      menu,
      contentdel,
      pop,
      callid,
      windowWidth,
    };
  },
  async created() {
    this.IsShow();
  },
});
</script>
